import React from "react";
import { TIDS } from "@/lib/testIds";
import { Compass, Wrench, Rocket, TrendingUp } from "lucide-react";

const steps = [
  {
    n: "01",
    title: "Audit & Diagnose",
    desc: "We deep-dive your practice, your local competition, your funnel and your numbers. You leave the call knowing exactly where you're leaking patients.",
    icon: Compass,
  },
  {
    n: "02",
    title: "Build The System",
    desc: "Ad accounts, funnels, tracking, review flows, call scripts, CRM automations, installed in 21 days, ready to scale.",
    icon: Wrench,
  },
  {
    n: "03",
    title: "Launch & Optimize",
    desc: "We go live, then A/B test creative, offers and audiences weekly until CPA is dialed and calendars are filling.",
    icon: Rocket,
  },
  {
    n: "04",
    title: "Scale Predictably",
    desc: "Once the box is printing bookings, we pour fuel: new channels, new offers, new locations. You just show up and treat.",
    icon: TrendingUp,
  },
];

export default function Process() {
  return (
    <section id="process" className="py-24 md:py-32 relative">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage: `url("https://images.pexels.com/photos/9062527/pexels-photo-9062527.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#070B14] via-[#070B14]/95 to-[#070B14] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <div className="font-mono-accent text-[11px] uppercase tracking-[0.25em] text-blue-400 mb-4">
            / 03 · Our process
          </div>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl tracking-tighter font-medium text-white leading-[1.05]">
            From chaos to a marketing system that runs itself.
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-white/20 to-transparent md:-translate-x-px" />

          <div className="space-y-16 md:space-y-24">
            {steps.map((s, i) => {
              const Icon = s.icon;
              const isRight = i % 2 === 1;
              return (
                <div
                  key={s.n}
                  data-testid={TIDS.processStep(s.n)}
                  className={`relative grid grid-cols-1 md:grid-cols-2 gap-8 items-center ${
                    isRight ? "md:[&>*:first-child]:col-start-2" : ""
                  }`}
                >
                  <div className={`${isRight ? "md:text-right md:pr-16" : "md:pl-16"} pl-16 md:pl-0`}>
                    <div className="font-mono-accent text-6xl md:text-7xl font-semibold text-white/[0.08] leading-none">
                      {s.n}
                    </div>
                    <h3 className="font-display text-2xl md:text-3xl tracking-tight text-white -mt-4 md:-mt-6">
                      {s.title}
                    </h3>
                    <p className="mt-4 text-white/60 leading-relaxed max-w-md md:inline-block">
                      {s.desc}
                    </p>
                  </div>

                  {/* Icon node */}
                  <div
                    className={`absolute left-6 md:left-1/2 top-2 -translate-x-1/2 w-12 h-12 rounded-full bg-[#070B14] border-2 border-amber-400 flex items-center justify-center shadow-[0_0_24px_rgba(245,158,11,0.35)]`}
                  >
                    <Icon className="w-5 h-5 text-amber-400" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
